import AlertMessage from '@/components/alertMessage/alertMessage';
import ShowHide from '@/components/showHide';
import Tooltip from '@/components/tooltip';
import Header from '@/core/components/header/header';
import HooksEvidencePanel from '@/modules/leadIndication/components/hooksEvidencePanel/hooksEvidencePanel';
import { LEAD_INDICATION_PAGE } from '@/modules/leadIndication/entities/leadIndication.const';
import useLeadIndicationPermissions from '@/modules/leadIndication/hooks/useLeadIndicationPermissions';
import { useHistoryLocation, useHistoryNavigator } from '@/navigation';
import ICONS from '@/shared/entities/constants/icons';
import React from 'react';
import { Button } from 'vkit/lib/components';

const List: React.FC = () => {
  const navigate = useHistoryNavigator();
  const { pathname } = useHistoryLocation();
  const { canWrite } = useLeadIndicationPermissions();

  return (
    <>
      <Header
        title={LEAD_INDICATION_PAGE.TITLE}
        description={LEAD_INDICATION_PAGE.DESCRIPTION}
        icon={LEAD_INDICATION_PAGE.ICON}>
        <Tooltip title={!canWrite ? LEAD_INDICATION_PAGE.WRITE_PERMISSION_ALERT_TITTLE : undefined}>
          <Button
            onClick={() => navigate.push(`${pathname}/actions/create`)}
            label={LEAD_INDICATION_PAGE.PRIMARY_ACTION_LABEL}
            color='colorDefault'
            icon={ICONS.SEND}
            iconColor={canWrite ? 'clear' : 'light'}
            disabled={!canWrite}
          />
        </Tooltip>
      </Header>

      <ShowHide transition='slideToDown' visible={!canWrite}>
        <AlertMessage
          title={LEAD_INDICATION_PAGE.WRITE_PERMISSION_ALERT_TITTLE}
          message={LEAD_INDICATION_PAGE.WRITE_PERMISSION_ALERT_MESSAGE}
          icon={ICONS.WARNING}
          color='warning'
        />
      </ShowHide>

      {/* TODO: painel temporário de evidência — Será removida na task https://vitta-dev.atlassian.net/browse/HEF-2953. */}
      <HooksEvidencePanel />
    </>
  );
};

export default List;
